import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { generateHeader } from "../../../utils/helpers/helperMethods/HeaderGenerator";

interface HeadlineProps {
  name?: string;
  subHeading?: string;
}
const Headline = ({ name, subHeading }: HeadlineProps) => {
  const [heading, setHeading] = React.useState<any>([]);
  let location = useLocation();

  useEffect(() => {
    setHeading(generateHeader(location.pathname));
  }, [location.pathname]);

  return (
    <div className="headline-row">
      {heading.length === 1 ? (
        <h1 className="headline-text">{heading[0].name}</h1>
      ) : name ? (
        <h1 className="headline-text">{name}</h1>
      ) : (
        ""
      )}

      {subHeading && <h2 className="sub-heading">{subHeading}</h2>}
    </div>
  );
};

export default Headline;
